const getters = {
    getAllTaskList: (state) => {
        return state.tasksList
            .map((item) => ({
                statusColor: item.status === "completed" ? "success" : getStatusColor(item.dueDate),
                ...item,
            }))
            .sort((a, b) => new Date(b.dueDate) - new Date(a.dueDate));
    },
    getFilterTaskList: (state, getters) => {
        let result = getters.getAllTaskList
        if (state.taskFilter !== "") {
            result = result.filter(
                (item) => item.statusColor === state.taskFilter
            );
        }
        if (state.myTaskFilter) {
            result = result.filter(obj => obj.assignees.some(item => item.email === state.myTaskFilter));
        }
        return result
    },
    getStatusLabel: (state, getters) => (key) => {
        const status = getters.translatedStatusList.find((item) => item.value === key);
        if (status) {
            return status.text;
        }
        return "not found";
    },
    translatedStatusList: (state) => {
        return state.statusList.map(item => ({ ...item, text: state.i18n.t(item.translationKey) }))
    },
};

function getStatusColor(duedate) {
    // To set two dates to two variables
    if (duedate == "-") {
        return "success";
    }
    var date1 = new Date();
    var date2 = new Date(duedate);

    // To calculate the time difference of two dates
    var Difference_In_Time = date2.getTime() - date1.getTime();

    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    if (Difference_In_Days < 0) return "error";
    // else if (Difference_In_Days > 10) return "success";
    else if (Difference_In_Days > 5) return "info";
    else if (Difference_In_Days > 0) return "warning";
    else return "info";
}

export default getters;
